import { CfsApi } from '@/api';
import { AssignedUnitShiftStatus } from '@/models';
import { IAccount } from '@/models/user';

import { CommandDefinition } from '../types';

export const ASSIGN_STATUS = 'ASSIGN';
export const ASSIGN_HQ_PREFIX = 'ASSIGN_TO_HQ:';
export const UPDATE_UNIT_SHIFT_STATUS_COMMAND_ID = 'UPDATE-UNIT-SHIFT-STATUS';

export const createUpdateUnitShiftStatusCommand = (
  account: IAccount | null,
): CommandDefinition => {
  const headquarters = account?.settings?.headquarters ?? [];

  const statusOptions = [
    { label: 'Assign', value: ASSIGN_STATUS, description: '' },
    ...headquarters.map((hq) => ({
      label: `Assign to ${hq.name}`,
      value: `${ASSIGN_HQ_PREFIX}${hq.name}`,
      description: '',
    })),
    {
      label: 'En Route',
      value: AssignedUnitShiftStatus.EN_ROUTE,
      description: '',
    },
    {
      label: 'In The Area',
      value: AssignedUnitShiftStatus.IN_THE_AREA,
      description: '',
    },
    {
      label: 'On Scene',
      value: AssignedUnitShiftStatus.ON_SCENE,
      description: '',
    },
    {
      label: 'In Progress',
      value: AssignedUnitShiftStatus.PROGRESS,
      description: '',
    },
    {
      label: 'Complete',
      value: AssignedUnitShiftStatus.COMPLETED,
      description: '',
    },
    {
      label: 'Cancel',
      value: AssignedUnitShiftStatus.CANCELED,
      description: '',
    },
  ];

  return {
    id: UPDATE_UNIT_SHIFT_STATUS_COMMAND_ID,
    label: 'Update Unit Shift Status',
    description: 'Assign or update status of units on a CFS',
    inputs: [
      {
        id: 'cfsId',
        label: 'CFS',
        type: 'select',
        required: true,
        placeholder: 'Select CFS',
        options: [],
      },
      {
        id: 'status',
        label: 'Status',
        type: 'select',
        required: true,
        placeholder: 'Select status',
        options: statusOptions,
      },
      {
        id: 'unitShiftIds',
        label: 'Unit(s)',
        type: 'select',
        required: true,
        multiSelect: true,
        placeholder: 'Select units',
        options: [],
      },
    ],
    execute: async (values) => {
      const { cfsId, status, unitShiftIds } = values;
      const ids: string[] = Array.isArray(unitShiftIds)
        ? unitShiftIds
        : [unitShiftIds];

      try {
        if (status === ASSIGN_STATUS) {
          await Promise.all(
            ids.map((id) => CfsApi.assignUnitShift(cfsId, id, false)),
          );
        } else if (
          typeof status === 'string' &&
          status.startsWith(ASSIGN_HQ_PREFIX)
        ) {
          const headquarterName = status.slice(ASSIGN_HQ_PREFIX.length);
          await Promise.all(
            ids.map((id) =>
              CfsApi.assignUnitShift(cfsId, id, true, headquarterName),
            ),
          );
        } else {
          await Promise.all(
            ids.map((id) =>
              CfsApi.updateAssignedUnitShiftStatus(cfsId, id, { status }),
            ),
          );
        }

        return {
          success: true,
          message: `Unit shift status updated successfully for ${ids.length} unit(s).`,
        };
      } catch (err: any) {
        return {
          success: false,
          message: err?.response?.data?.message ?? 'An unknown error occurred',
        };
      }
    },
  };
};
